import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./Layout.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { logout } from "../../../actions/Dashboard.action";
import { connect } from "react-redux";
import { FiLogOut } from "react-icons/fi";
import { GoThreeBars } from "react-icons/go";

import { FaTimes } from "react-icons/fa";
import { AiOutlineHome } from "react-icons/ai";
import { BsStack } from "react-icons/bs";
import { BiMessageSquareDetail } from "react-icons/bi";

const Layout = ({ logout, children }) => {
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);

  const logoutHandeler = async () => {
    let check = await logout();
    if (check === true) {
      navigate("/");
    }
  };
  return (
    <div>
      <Container fluid>
        <Row className="position-relative">
          <Col
            md={2}
            className={`px-4 pt-md-4 pt-0 ${styles.wrapper} ${
              show ? styles.active : ""
            }`}
          >
            <div className="d-flex justify-content-between align-items-center w-100">
              <div
                className={`${styles.ham}  ms-auto`}
                onClick={() => setShow(!show)}
              >
                <FaTimes />
              </div>
            </div>

            <div className={styles.nav}>
              <NavLink to="/" className={styles.nav__item}>
                <span className={styles.icon}>
                  <AiOutlineHome />
                </span>
                <span className={styles.nav__item_text}>Home</span>
              </NavLink>
            </div>
            <div className={styles.nav}>
              <NavLink to="/dashboard" className={styles.nav__item}>
                <span className={styles.icon}>
                  <BsStack />
                </span>
                <span className={styles.nav__item_text}>Products</span>
              </NavLink>
            </div>
            <div className={styles.nav}>
              <NavLink to="/contact-submissions" className={styles.nav__item}>
                <span className={styles.icon}>
                  <BiMessageSquareDetail />
                </span>
                <span className={styles.nav__item_text}>Contacts</span>
              </NavLink>
            </div>

            <div className={styles.nav}>
              <div className={styles.nav__item} onClick={logoutHandeler}>
                <span className={styles.icon}>
                  <FiLogOut />
                </span>
                <span className={styles.nav__item_text}>Logout</span>
              </div>
            </div>
          </Col>
          <Col md={10} className="bg-light">
            <div className="d-flex justify-content-end align-items-center py-3">
              <div
                className={`${styles.ham}  me-auto`}
                onClick={() => setShow(!show)}
              >
                <GoThreeBars />
              </div>
              {/* <h3 className="me-auto ps-4 fs-3 my-auto">{title}</h3> */}
            </div>
            <Container>{children}</Container>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default connect(null, { logout })(Layout);
